import { IonAvatar, IonItem, IonLabel } from '@ionic/react';
import { DEFAULT_AVATAR_URL } from '../../../../appConfig';
import { withAvatarCacheBuster } from '../../../../lib/avatarUrl';

interface Follower {
  id: string;
  fullName?: string | null;
  picture?: string | null;
  updatedAt?: string | null;
}

interface Props {
  follower: Follower;
}

export const FollowerCard: React.FC<Props> = ({ follower }) => {
  const name = follower.fullName || 'Usuario';

  return (
    <IonItem>
      <IonAvatar slot="start" className="w-10 h-10 mr-3">
        <img
          src={withAvatarCacheBuster(follower.picture, follower.updatedAt) || DEFAULT_AVATAR_URL}
          alt={`Foto de ${name}`}
          className="w-full h-full object-cover rounded-full"
        />
      </IonAvatar>
      <IonLabel className="text-base text-gray-900">{name}</IonLabel>
    </IonItem>
  );
};
